export default __webpack_public_path__ + "c5f12e8f962f0e8ac39d96db126ceaca.png";